// Source/Shadow-Block/Component.ts
class ShadowBlock extends HTMLElement {
  connectedCallback() {
    if (!this.shadowRoot)
      this.attachTemplate();
  }
  attachTemplate() {
    const { $template } = this;
    if (!$template)
      return;
    const fragment = $template.content;
    const clone = fragment.cloneNode(true);
    const shadow = this.attachShadow({
      mode: "open"
    });
    shadow.append(clone);
  }
  get $template() {
    return this.querySelector(`:scope > template[ shadowrootmode = 'open' ]`);
  }
}

// Source/Navigation-Section/Component.ts
class Navigation_Section extends ShadowBlock {
  controller;
  disconnectedCallback() {
    this.controller.abort();
  }
  connectedCallback() {
    super.connectedCallback();
    this.controller = new AbortController;
    this.listen();
    this.update();
  }
  listen() {
    const { signal } = this.controller;
    window.addEventListener("scroll", this.update.bind(this), {
      passive: true,
      signal
    });
  }
  update() {
    const scrolled = window.scrollY > 0;
    this.$header.dataset.scrolled = String(scrolled);
  }
  get $header() {
    return this.closest(`header`);
  }
}

// Source/Navigation-Section/mod.ts
customElements.define("navigation-section", Navigation_Section);
